/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styled from 'styled-components';
import { DrawerDescList } from './DrawerDescList';
const DrawerRow = styled.tr `
  &&& {
    background: initial;
    box-shadow: 0 4px 5px rgba(0, 0, 0, 0.04) inset;
  }
`;
const Drawer = ({ tableInstance, row, drawer, isOpen, panelId, targetRef, }) => {
    if (!isOpen)
        return null;
    const [drawerRow] = row.subRows;
    if (!drawerRow)
        return null;
    tableInstance.prepareRow(drawerRow);
    return (React.createElement(DrawerRow, Object.assign({}, drawerRow.getRowProps(), { id: panelId, "data-testid": panelId }),
        React.createElement("td", { colSpan: row.cells.filter(cell => !cell.column.isDrawerOnly).length },
            React.createElement("div", null,
                React.createElement(DrawerDescList, { row: row, drawer: drawer, targetRef: targetRef })))));
};
export { Drawer };
//# sourceMappingURL=Drawer.js.map